
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';

export const GhostCardPreview: React.FC = () => {
    return (
        <Card noPadding className="bg-[#0A0B0F] text-white border-white/10 flex flex-col justify-between h-44 relative overflow-hidden group rounded-sm shadow-md">
            <div className="p-8 relative z-10">
                <div className="flex justify-between items-start">
                    <div className="space-y-1">
                        <div className="text-[10px] font-black text-stone-500 uppercase tracking-widest">Ghost Card v2 (Sandbox)</div>
                        <div className="text-2xl font-mono mt-2 tracking-[0.25em]">•••• 1337</div>
                    </div>
                    <div className="px-3 py-1 rounded-sm bg-emerald-500/10 text-emerald-500 text-[9px] font-black uppercase tracking-widest border border-emerald-500/20">Active</div>
                </div>
            </div>
            <div className="p-8 relative z-10 flex justify-between items-end">
                <div>
                    <div className="text-[9px] text-stone-600 font-black uppercase mb-1">24H LIMIT</div>
                    <div className="text-xl font-bold text-white tracking-tight">$5,000 <span className="text-stone-600 text-[11px] font-medium">/ DAILY</span></div>
                </div>
                <Button variant="outline" size="sm" className="h-10 px-6 text-[10px] border-white/10 hover:bg-white hover:text-black">MANAGE</Button>
            </div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-nobel-gold opacity-[0.02] blur-3xl pointer-events-none" />
        </Card>
    );
};
